import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../state/auth';

export function useRequireAuth() {
  const status = useAuthStore(s => s.status);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (status === 'anonymous') {
      navigate(`/login?next=${encodeURIComponent(location.pathname + location.search)}`, { replace: true });
    }
  }, [status, navigate, location]);

  return status;
}
